import React from 'react';
import bemit from 'Functions/bemit';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import InstagramIcon from 'Icons/Instagram';
import FacebookIcon from 'Icons/Facebook';
import PhoneIcon from 'Icons/Phone';
import AtIcon from 'Icons/AtIcon';
import GLOBAL_CONFIG from 'Shared/config';
import { getSpacedPhoneNumber } from 'Shared/utilities';
import { URL } from 'Shared/Routes';
const {
  app
} = window;
export default function Footer({
  ...props
}) {
  const modifiers = [].concat(props.bemit || []);
  const bottom_footer = /*#__PURE__*/React.createElement("div", {
    className: "c-footer__bottom"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-footer__copyright"
  }, "\xA9\xA0Tous droits r\xE9serv\xE9s BestWestern 2023"), /*#__PURE__*/React.createElement("ul", {
    className: "c-footer__legal-links"
  }, props.simple ? /*#__PURE__*/React.createElement("li", {
    className: "c-footer__legal-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://proachat.net/fr/",
    target: "_blank",
    rel: "nofollow noreferrer",
    className: "c-footer__legal-link"
  }, "myWO")) : undefined, /*#__PURE__*/React.createElement("li", {
    className: "c-footer__legal-item"
  }, /*#__PURE__*/React.createElement(Link, {
    href: URL('LegalPage'),
    rel: "nofollow",
    className: "c-footer__legal-link"
  }, "Mentions l\xE9gales")), /*#__PURE__*/React.createElement("li", {
    className: "c-footer__legal-item"
  }, /*#__PURE__*/React.createElement(Link, {
    href: URL('CGUPage'),
    rel: "nofollow",
    className: "c-footer__legal-link"
  }, "Conditions g\xE9n\xE9rales d'utilisation et de vente"))));
  if (props.simple) {
    modifiers.push('simple');
    const output = /*#__PURE__*/React.createElement("footer", {
      className: bemit('c-footer', modifiers)
    }, bottom_footer);
    return output;
  }
  const output = /*#__PURE__*/React.createElement("footer", {
    className: bemit('c-footer', modifiers)
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__left"
  }, /*#__PURE__*/React.createElement(Logo, {
    className: "c-footer__logo",
    type: "full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-footer__links"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__links-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__link-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__link-txt"
  }, "\xC0 propos"), /*#__PURE__*/React.createElement(Link, {
    href: URL('ConceptPage'),
    className: "c-footer__link"
  }, "Notre concept"), /*#__PURE__*/React.createElement(Link, {
    className: "c-footer__link",
    href: URL('CompanyOfferPage')
  }, "Offre entreprise"), /*#__PURE__*/React.createElement(Link, {
    className: "c-footer__link",
    href: URL('Login')
  }, "Acc\xE8s h\xF4telier")), /*#__PURE__*/React.createElement("div", {
    className: "c-footer__link-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-footer__link-txt"
  }, "Service client France"), /*#__PURE__*/React.createElement("a", {
    onClick: onPhoneClick,
    href: 'tel:' + GLOBAL_CONFIG.contact_phone,
    className: "c-footer__link with-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-footer__link-icon"
  }, /*#__PURE__*/React.createElement(PhoneIcon, {
    className: "c-footer__link-svg"
  }), /*#__PURE__*/React.createElement(PhoneIcon, {
    className: "c-footer__link-mask"
  }), /*#__PURE__*/React.createElement("span", {
    className: "u-readers-only"
  }, "Ic\xF4ne de t\xE9l\xE9phone")), getSpacedPhoneNumber(GLOBAL_CONFIG.contact_phone).split(' ').join('.')), /*#__PURE__*/React.createElement("a", {
    onClick: onEmailClick,
    href: 'mailto:' + GLOBAL_CONFIG.contact_email,
    className: "c-footer__link with-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-footer__link-icon"
  }, /*#__PURE__*/React.createElement(AtIcon, {
    className: "c-footer__link-svg"
  }), /*#__PURE__*/React.createElement(AtIcon, {
    className: "c-footer__link-mask"
  }), /*#__PURE__*/React.createElement("span", {
    className: "u-readers-only"
  }, "Ic\xF4ne de mail")), GLOBAL_CONFIG.contact_email)), /*#__PURE__*/React.createElement("div", {
    className: "c-footer__link-item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-footer__social-txt"
  }, "R\xE9seaux sociaux"), /*#__PURE__*/React.createElement("ul", {
    className: "c-footer__social-links"
  }, /*#__PURE__*/React.createElement("li", {
    className: "c-footer__social-link-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: GLOBAL_CONFIG.social_networks.facebook,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "c-footer__social-link",
    "aria-label": "Page Facebook myWO"
  }, /*#__PURE__*/React.createElement(FacebookIcon, {
    className: "c-footer__social-icon"
  }), /*#__PURE__*/React.createElement(FacebookIcon, {
    className: "c-footer__social-icon-mask"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "c-footer__social-link-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: GLOBAL_CONFIG.social_networks.instagram,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "c-footer__social-link",
    "aria-label": "Page Instagram myWO"
  }, /*#__PURE__*/React.createElement(InstagramIcon, {
    className: "c-footer__social-icon"
  }), /*#__PURE__*/React.createElement(InstagramIcon, {
    className: "c-footer__social-icon-mask"
  })))))))), bottom_footer, props.children);
  return output;
  function onPhoneClick(e) {
    e.persist();
    app.emit({
      event: 'TC_Click',
      source: 'Footer',
      data: {
        e: e,
        action: 'service_client_numero'
      }
    });
  }
  function onEmailClick(e) {
    e.persist();
    app.emit({
      event: 'TC_Click',
      source: 'Footer',
      data: {
        e: e,
        action: 'service_client_mail'
      }
    });
  }
}
